import React, { useState, useEffect, Dispatch, SetStateAction } from "react";
import { toast } from "react-toastify";
import {
  getCouponPromotionState,
  getPointPromotionState,
} from "../../../../../ApiTS/ApiPromotionTS";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import Blank from "../../../../DefaultStyles/Blank";
import { Input } from "../../../../Input/Input";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { ValueContainer } from "../CouponPointRegisterModal";
import CouponPreviewBox from "./CouponPreviewBox";

interface GeneralRegisterProps {
  isPoint?: boolean;
  promId?: string;
  setPromId: Dispatch<SetStateAction<string | undefined>>;
  previewBtnClick: boolean;
  setPreviewBtnClick: Dispatch<SetStateAction<boolean>>;
}

export default function GeneralRegister({
  isPoint,
  promId,
  setPromId,
  previewBtnClick,
  setPreviewBtnClick,
}: GeneralRegisterProps) {
  const [value, setValue] = useState<string | undefined>("");

  const selectPromotionData =
    promId !== ""
      ? isPoint
        ? getPointPromotionState(Number(promId))
        : getCouponPromotionState(Number(promId))
      : undefined;

  console.log(selectPromotionData);

  useEffect(() => {
    if (
      previewBtnClick &&
      (selectPromotionData?.type === -1 || selectPromotionData === undefined)
    ) {
      toast.error("유효하지 않은 Promotion ID입니다.", {});
      setPreviewBtnClick(false);
    }
  }, [previewBtnClick, selectPromotionData]);

  return (
    <>
      {/* Promotion ID */}
      <ModalRow>
        <ModalLabel>Promotion ID</ModalLabel>

        <ValueContainer>
          <Input
            placeholder="직접 입력(Promotion ID)"
            value={value}
            onChange={(e) => setValue(String(e.target.value))}
            type="number"
            inputMode="numeric"
            style={{ width: "calc(100% - 10px - 85px)" }}
          />

          <ConfirmBtn
            btnText="미리보기"
            btnColor="mint"
            isDisabled={value === ""}
            btnClickEvent={() => {
              setPromId(value);
              setPreviewBtnClick(true);
            }}
          />
        </ValueContainer>
      </ModalRow>

      {/* 쿠폰/포인트 미리보기 */}
      <ModalLabel>{isPoint ? "포인트" : "쿠폰"} 미리보기</ModalLabel>

      <Blank marginHeight={16} blankHeight={0} />

      <CouponPreviewBox
        selectPromotionData={selectPromotionData?.data}
        isPoint={isPoint}
      />

      <Blank
        blankHeight={selectPromotionData?.data ? 40 : 16}
        marginHeight={selectPromotionData?.data ? 40 : 16}
      />
    </>
  );
}
